module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('form', {
    attrs: {
      "name": "signupForm"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [(_vm.role === 'TRAINEE') ? _c('h1', [_vm._v("Signup for LogBox Academic - Email Verification")]) : _vm._e(), _vm._v(" "), (_vm.role === 'HOD') ? _c('h1', [_vm._v("Signup for LogBox Academic - Supervisor Activation")]) : _vm._e()])])]), _vm._v(" "), (_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), (_vm.verified) ? _c('div', [_vm._v("Your account has now been activated. Please click the button below to login.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline",
      "float": "right"
    }
  }, [(_vm.verified) ? _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button",
      "id": "login-submit-button",
      "name": "login-submit-button"
    },
    on: {
      "click": function($event) {
        return _vm.redirectLogin()
      }
    }
  }, [_vm._v("\n                  Login\n                ")]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "15px",
      "margin-right": "11px"
    },
    attrs: {
      "src": require("assets/images/logbox_logo_sm.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-107ad7b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/VerifyEmail.vue
// module id = 651
// module chunks = 5